/* unplugin-vue-components disabled */import i18n from '@/lang';
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
/* this file is transformed by vux-loader */
/* eslint-disable */
import _toConsumableArray from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "G:/SVN/\u5355\u5C0F\u4E8C/\u6E90\u4EE3\u7801/\u5BA2\u6237\u7AEF\u95E8\u6237/front/smy-toc-vux-cli3/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.object.freeze.js";
import "core-js/modules/es.array.concat.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ScrollerList from '@/components/ScrollerList';
import Cell from "vux/src/components/cell/index.vue"; // this line is trasformed by vux-loader
import Search from "vux/src/components/search/index.vue"; // this line is trasformed by vux-loader
import TransferDom from "vux/src/directives/transfer-dom/index.js"; // this line is trasformed by vux-loader
import Tab from "vux/src/components/tab/tab.vue"; // this line is trasformed by vux-loader
import TabItem from "vux/src/components/tab/tab-item.vue"; // this line is trasformed by vux-loader
import ViewBox from "vux/src/components/view-box/index.vue"; // this line is trasformed by vux-loader
import XButton from "vux/src/components/x-button/index.vue"; // this line is trasformed by vux-loader
import { sendrevisedorderlist } from '@/api';
export default {
  name: 'repairRecord',
  components: {
    Cell: Cell,
    Search: Search,
    Tab: Tab,
    TabItem: TabItem,
    ViewBox: ViewBox,
    ScrollerList: ScrollerList,
    XButton: XButton
  },
  data: function data() {
    return {
      searchForm: {
        keyword: ''
      },
      pageIndex: 0,
      pageSize: 20,
      orderList: []
    };
  },
  computed: {
    // 计算滚动区域高度
    scrollerHight: function scrollerHight() {
      // eslint-disable-next-line
      var fontSize = window.getComputedStyle(window.document.documentElement)['font-size'];
      fontSize = Number(fontSize.substr(0, fontSize.length - 2));
      return document.documentElement.clientHeight - 4 * fontSize;
    }
  },
  methods: {
    replaceMultiImg: function replaceMultiImg(urls) {
      if (!urls) return '';
      var urlArr = urls.split(',');
      return urlArr[0];
    },
    loadList: function loadList() {
      var _this = this;
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var operation = arguments.length > 1 ? arguments[1] : undefined;
      if (reset) {
        this.pageIndex = 0;
        this.$vux.loading.show({
          text: i18n.tc("206")
        });
      }
      return new Promise(function (resolve, reject) {
        var data = _objectSpread({
          pageIndex: _this.pageIndex,
          pageSize: _this.pageSize
        }, _this.searchForm);
        sendrevisedorderlist(data).then(function (res) {
          // 不重置数据累计
          res.data = res.data || [];
          setTimeout(function () {
            _this.$vux.loading.hide();
          }, 300);
          if (!reset) {
            _this.orderList = Object.freeze([].concat(_toConsumableArray(_this.orderList), _toConsumableArray(res.data)));
          } else {
            _this.orderList = Object.freeze(res.data);
          }
          if (operation === 'search' && _this.$refs.orderList) {
            _this.$refs.orderList.scrollToTop();
          }
          resolve();
          _this.$refs['orderList'] && _this.$refs['orderList'].donePulldown();
          if (res.data.length >= _this.pageSize) {
            _this.$refs['orderList'] && _this.$refs['orderList'].donePullup();
          } else {
            _this.$refs['orderList'] && _this.$refs['orderList'].disablePullup();
          }
        });
      });
    },
    onPulldownLoading: function onPulldownLoading() {
      this.loadList(true).then(function () {});
    },
    onPullupLoading: function onPullupLoading() {
      this.pageIndex = this.pageIndex + 1;
      this.loadList().then(function () {});
    },
    getStateInfo: function getStateInfo(item) {
      var state = 0;
      var orderInfo = item;
      var acceptance_state = +orderInfo.acceptance_state;
      var sign_state = +orderInfo.sign_state;
      var sendOutState = +orderInfo.sendOutState;
      var send_state = +orderInfo.send_state;
      // 受理状态// 取消状态// 完成状
      if (sendOutState === 2) {
        state = 6;
      } else if (sendOutState === 1) {
        state = 5;
      } else if (sign_state === 2) {
        state = 4;
      } else if (sign_state === 1) {
        state = 3;
      } else if (acceptance_state === 1 && send_state === 1) {
        state = 2;
      } else if (acceptance_state === 1) {
        state = 1;
      } else if (acceptance_state === 0) {
        state = 0;
      }
      var states = [{
        id: 0,
        color: '#fa5d3a',
        name: i18n.tc("386")
      }, {
        id: 1,
        color: '#fa5d3a',
        name: i18n.tc("54")
      }, {
        id: 2,
        color: '#248bf7',
        name: i18n.tc("387")
      }, {
        id: 3,
        color: '#0abd12',
        name: i18n.tc("388")
      }, {
        id: 4,
        color: '#cf1f12',
        name: i18n.tc("389")
      }, {
        id: 5,
        color: '#0abd12',
        name: i18n.tc("390")
      }, {
        id: 6,
        color: '#cf1f12',
        name: i18n.tc("391")
      }];
      return states[state];
    }
  },
  created: function created() {
    this.loadList(true);
  }
};